import {
  BasePagination,
  SORT_DIRECTION,
} from "api/interfaces/commonInterface.interface";
import { useMemo } from "react";

export const getQueryKey = (
  params: Record<string, any>
): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([key]) => key !== "total" && key !== "pageLimit"
    )
  );
};

export const useQueryKey = (params: Record<string, any>) => {
  return useMemo(() => getQueryKey(params), [params]);
};

export const baseQueryInfo: BasePagination = {
  total: 0,
  pageNum: 0,
  pageLimit: 20,
  keyword: "",
  sortType: "name",
  sortDirection: SORT_DIRECTION.ASC,
};
